import { useEffect } from "react";
import usePagination from "./usePagination";
import { useQuery, useSubscription } from "@apollo/client";
import { OnLastOfflineDevices } from "graphql/subscriptions/offline_devices";
import { GET_OFFLINE_DEVICES } from "graphql/queries/offline_devices";
import { IOfflineDevice, IOfflineDeviceIndexParams } from "models/OfflineDevice";

const useOfflineDevices = ({
    page: externalPage,
    pageSize: externalPageSize,
    orderBy = "desc",
    deviceType,
    startDate,
    endDate
}: IOfflineDeviceIndexParams) => {

    const hookOfflineDevices = usePagination<IOfflineDevice>({
        page: externalPage,
        pageSize: externalPageSize,
        sortOrder: orderBy as "desc" | "asc"
    });

    const { page, pageSize } = hookOfflineDevices;
    const { data, loading } = useQuery(GET_OFFLINE_DEVICES(page, pageSize, orderBy as "desc" | "asc", deviceType, startDate, endDate), {
        // pollInterval: 1000*60, //Actualiza cada minuto
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
    });

    const { data: lastDataOfflineDevice } = useSubscription(OnLastOfflineDevices);

    useEffect(() => {
        if (lastDataOfflineDevice) {
            const newElement = lastDataOfflineDevice.its_offline_devices[0];
            // Agregar si está en el rango de fechas
            if(startDate && endDate && startDate <= newElement.created_at && endDate >= newElement.created_at) {
                hookOfflineDevices.addElement(newElement)
            }
        }
    }, [lastDataOfflineDevice]);

    useEffect(() => {
        if (loading) {
            hookOfflineDevices.loadingStart();
        } else {
            hookOfflineDevices.loadingEnd();
        }

        if (data) {
            const { its_offline_devices: dataETDStatus, its_offline_devices_aggregate } = data;
            const { count: totalItems } = its_offline_devices_aggregate.aggregate;
            hookOfflineDevices.setData(dataETDStatus);
            hookOfflineDevices.setTotalItems(totalItems);
        }
    }, [data, loading]);

    return hookOfflineDevices;
};

export default useOfflineDevices;
